module.exports = __webpack_public_path__ + "img/wenjian-imgss.0774ca79.png";